import { render, staticRenderFns } from "./gem.vue?vue&type=template&id=c57843a4&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../DATA/projects/mikobi_house/admin-ctv/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../DATA/projects/mikobi_house/admin-ctv/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
